import { Attributes, Rules, Validation, ValueObject } from '@singularsystems/neo-core';
import { Display } from '@singularsystems/neo-core/dist/Model/Decorators';
import { FieldSetting } from './FieldSetting';
import { MandatoryAndVisibleSetting, MandatorySetting, VisibleSetting } from './FieldSetting.enum';

export default class InvestorFieldConfig extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @FieldSetting(MandatorySetting)
    public companyRegNo: MandatorySetting = MandatorySetting.NotMandatory;

    @FieldSetting(MandatorySetting)
    public title: MandatorySetting = MandatorySetting.Mandatory;

    @FieldSetting(MandatorySetting)
    public mastersRefNo: MandatorySetting = MandatorySetting.NotMandatory;

    public internalAccountNo: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(String)
    @Rules.StringLength(50)
    public internalAccountNoLabel: string = "";

    public externalAccountNo: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(String)
    @Rules.StringLength(50)
    public externalAccountNoLabel: string = "";

    @FieldSetting(String)
    @Rules.StringLength(50)
    public externalRelationshipManagerLabel: string = "";

    public taxRefNo: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public postalAddress: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public physicalAddress: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Country")
    public countryId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Additional Bank Details")
    public additionalBankDetails: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Authorised Contact Person")
    @FieldSetting(MandatorySetting)
    public authorisedPersonContactId: MandatorySetting = MandatorySetting.NotMandatory;

    @FieldSetting(MandatorySetting)
    public contactEmails: MandatorySetting = MandatorySetting.NotMandatory;

    @Display("Contacts")
    @FieldSetting(MandatorySetting)
    public contacts: MandatorySetting = MandatorySetting.NotMandatory;

    public withholdingAgentRefNumber: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public beneficiaryName: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public beneficiaryTaxReferenceNumber: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public beneficiaryPhysicalAddress: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("DWT Exemptions")
    @FieldSetting(VisibleSetting)
    public dwtExemptionId: VisibleSetting = VisibleSetting.Visible;

    public portfolioTypeId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public ficaDate: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Sanctioned Screening Performed")
    @FieldSetting(VisibleSetting)
    public sanctionedScreenPerformed: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public commission: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public commissionDiv: VisibleSetting = VisibleSetting.Visible;

    public ledgerAccount: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Restricted From Trading")
    @FieldSetting(VisibleSetting)
    public isRestricted: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public isLetterPasswordProtected: VisibleSetting = VisibleSetting.Visible;

    @Display("SARS Nature Of Person")
    public sarsNatureOfPersonId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Investor Referral Type")
    public investorReferralTypeId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public shortName: VisibleSetting = VisibleSetting.Hidden;

    @Display("Intra Group")
    public intraGroupId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Sector")
    public sectorId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Investor Fields Config";
    }
}